/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, OrganisationListEntryFromJSON, OrganisationListEntryToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfOrganisationListEntryFromJSON(json) {
    return PagedResponseOfOrganisationListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfOrganisationListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(OrganisationListEntryFromJSON)),
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'page': !exists(json, 'page') ? undefined : json['page']
    };
}
export function PagedResponseOfOrganisationListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'numberOfElements': value.numberOfElements,
        'metaData': MetaDataToJSON(value.metaData),
        'totalElements': value.totalElements,
        'hasNext': value.hasNext,
        'size': value.size,
        'previousPage': PageRequestToJSON(value.previousPage),
        'hasPrevious': value.hasPrevious,
        'entries': value.entries === undefined ? undefined : (value.entries.map(OrganisationListEntryToJSON)),
        'nextPage': PageRequestToJSON(value.nextPage),
        'page': value.page
    };
}
